<div
  class="scw-mat-select-container"
  [class.has-errors]="hasErrors"
  [class.no-padding]="noPadding"
  [class.select-sm]="size === 'sm'"
  [class.select-md]="size === 'md'"
>
  <label class="select-label" *ngIf="label">{{ label }}</label>
  <angular2-multiselect
    [data]="_.isEmpty(search) || searchBehavior !== 'live' ? data : searchResult"
    [settings]="settings"
    [(ngModel)]="inputModel"
    (ngModelChange)="onNgModelChange()"
    (onClose)="onCloseEmitter($event)"
    (onSelect)="onSelectEmitter($event)"
    (onDeSelect)="onDeSelectEmitter($event)"
    (onSelectAll)="onSelectAllEmitter($event)"
    (onDeSelectAll)="onDeSelectAllEmitter($event)"
    (onGroupSelect)="onGroupSelectEmitter($event)"
    (onGroupDeSelect)="onGroupDeSelectEmitter($event)"
    (onScrollToEnd)="onScrollToEndEmitter($event)"
    (onOpen)="onOpenEmitter($event)"
  >
    <c-search>
      <ng-template>
        <scw-mat-search
          [buttonPosition]="searchButtonPosition"
          [placeholder]="settings.searchPlaceholderText"
          [behavior]="searchBehavior"
          [searchDelay]="searchDelay"
          [minLength]="searchMinLength"
          [maxLength]="searchMaxLength"
          [preventSameSearchString]="searchPreventSameSearchString"
          [(inputModel)]="rawSearchString"
          (onSearch)="onSearchString($event)"
          #searchComponent
        ></scw-mat-search>
        <ng-template [ngIf]="advancedSelect">
          <scw-mat-small-button
            [className]="['scw-mat-small-button-refresh-icon-button']"
            [disabled]="disabled"
            [iconButton]="true"
            (onClick)="onSearchStringRefresh()"
          >
            <em class="fas fa-sync-alt"></em>
          </scw-mat-small-button>
          <scw-mat-small-button
            [className]="['scw-mat-small-button-add-icon-button']"
            [disabled]="disabled"
            [iconButton]="true"
            (onClick)="onAddEmitter()"
          >
            <em class="fas fa-plus"></em>
          </scw-mat-small-button>
        </ng-template>
      </ng-template>
    </c-search>
    <c-item *ngIf="cItemTemplate">
      <ng-template let-item="item">
        <ng-template *ngTemplateOutlet="cItemTemplate; context: { data: item }"> </ng-template>
      </ng-template>
    </c-item>
  </angular2-multiselect>
  <mat-progress-bar mode="indeterminate" [color]="'primary'" [hidden]="!isLoading"></mat-progress-bar>
  <ng-template [ngIf]="errorText || hint">
    <div class="sub-text" [class.error]="errorText" [class.hint]="!errorText && hint">
      <em
        class="sub-text-icon fas"
        [class.fa-exclamation-circle]="errorText"
        [class.fa-info-circle]="!errorText && hint"
      ></em>
      <ng-template [ngIf]="errorText">{{ errorText }}</ng-template>
      <ng-template [ngIf]="!errorText && hint">{{ hint }}</ng-template>
    </div>
  </ng-template>
</div>
